import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import classNames from 'clsx';
import type { FC } from 'react';
import React from 'react';

import semanticClassNames from '../SocialPlayerFacebook.semanticClassNames';
import type { SocialPlayerFacebookProps } from '../SocialPlayerFacebook.types';
import classes from './SocialPlayerFacebook.module.scss';
import { toEmbedUrl } from './SocialPlayerFacebook.utils';

const SocialPlayerFacebook: FC<SocialPlayerFacebookProps> = props => {
  const {
    id,
    className,
    customClassNames = [],
    url,
    description,
    autoPlay = false,
    enabledCaptions = false,
    onMouseEnter,
    onMouseLeave,
  } = props;

  return (
    <div
      id={id}
      className={classNames(
        classes.root,
        className,
        formatClassNames(semanticClassNames.root, ...customClassNames),
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ display: 'flex', minHeight: 'fit-content' }}
      {...getDataAttributes(props)}
    >
      {url ? (
        <iframe
          className={classNames(
            classes.iFrame,
            formatClassNames(semanticClassNames.iFrame),
          )}
          title={description}
          src={toEmbedUrl(url, { autoPlay, enabledCaptions })}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          allowFullScreen={true}
          allowTransparency={true}
          loading="lazy"
        />
      ) : null}
    </div>
  );
};

export default SocialPlayerFacebook;
